import { SummaryFeatureList } from '~app/pages/Pricing/transformers/summary/types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const BasicFeatureList: SummaryFeatureList = [
  'grow_2792_user',
  'grow_2792_survey_create_limit', // Unlimited surveys and forms
  'grow_2792_basic_create_question_limit', // 10 questions per survey
  'grow_2792_question_types', // Essential question types only
  'grow_2792_basic_base_response_count', // 25 responses per survey
  'grow_2792_support', // 24/7 email support
];

export default BasicFeatureList;
